<script>
import NewsletterForm from '@phoenix/mixins/components/form/NewsletterForm';
import formWithImage from '@maison/mixins/formWithImage';
import PictureLazy from '@maison/components/common/PictureLazy';
import { set } from 'lodash-es';

export default {
  components: {
    PictureLazy,
  },

  mixins: [NewsletterForm, formWithImage],

  props: {
    onSuccessCallback: {
      type: Function,
      default: () => ({}),
    },
    singleColumn: {
      type: Boolean,
      default: false,
    },
    prefillEmailValue: {
      type: String,
      default: '',
    },
    showErrorsInToast: {
      type: Boolean,
      default: true,
    },
    showSuccessInToast: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      hasTwoColumns: !this.singleColumn,
    };
  },

  watch: {
    prefillEmailValue(value) {
      if (value !== '') {
        set(this.fields, ['email', 'value'], value);
      }
    },
  },

  methods: {
    async successCallback() {
      await this.addTrackingInformation();
      this.onSuccessCallback();
    },
  },
};
</script>

<template>
  <div :class="wrapperClasses">
    <phoenix-form
      v-model="fields"
      :prefill-enabled="true"
      :redirect-url="redirectUrl"
      :terms-link="termsLink"
      :privacy-link="privacyLink"
      :on-success-callback="successCallback"
      :captcha-enabled="enableCaptcha"
      :action="action"
      form-type="newsletter"
      korean-form-type="newsletter"
      :is-submit-on-left="hasImage"
      :show-errors-in-toast="showErrorsInToast"
      :show-success-in-toast="showSuccessInToast"
    >
      <div>
        <h1 v-if="title" class="h2 mb-base">{{ title }}</h1>
        <p v-if="subtitle" class="mb-lg">{{ subtitle }}</p>

        <div :class="gridClasses">
          <div :class="columnClasses">
            <form-group :attrs="fields.country">
              <select-field v-model="fields.country.value" />
            </form-group>
            <form-group v-if="fieldIsPresent('email')" :attrs="fields.email">
              <text-field v-model="fields.email.value" />
            </form-group>
          </div>
          <div :class="columnClasses">
            <form-group v-if="fieldIsPresent('title')" :attrs="fields.title">
              <select-field v-model="fields.title.value" />
            </form-group>
            <form-group v-if="fieldIsPresent('gender')" :attrs="fields.gender">
              <select-field v-model="fields.gender.value" />
            </form-group>
            <form-group v-if="fieldIsPresent('firstName2') && isArabicLanguage" :attrs="fields.firstName2">
              <text-field v-model="fields.firstName2.value" />
            </form-group>
            <form-group v-if="fieldIsPresent('lastName2') && isArabicLanguage" :attrs="fields.lastName2">
              <text-field v-model="fields.lastName2.value" />
            </form-group>
            <form-group v-if="fieldIsPresent('firstName1')" :attrs="fields.firstName1">
              <text-field v-model="fields.firstName1.value" />
            </form-group>
            <form-group v-if="fieldIsPresent('lastName1')" :attrs="fields.lastName1">
              <text-field v-model="fields.lastName1.value" />
            </form-group>
            <form-group v-if="fieldIsPresent('firstName2') && !isArabicLanguage" :attrs="fields.firstName2">
              <text-field v-model="fields.firstName2.value" />
            </form-group>
            <form-group v-if="fieldIsPresent('lastName2') && !isArabicLanguage" :attrs="fields.lastName2">
              <text-field v-model="fields.lastName2.value" />
            </form-group>
          </div>
        </div>
      </div>
    </phoenix-form>

    <div v-if="hasImage" class="max-sm:hidden">
      <div class="picture">
        <picture-lazy v-bind="image" />
      </div>
    </div>
  </div>
</template>
